/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Inputmask from 'inputmask';
import App from '../helpers/app';

let PluginInputMask = new function(){
    let me = this;

    Inputmask.extendAliases({
        'phone': {
            "mask": "+48 999 999 999",
            showMaskOnHover: false
        },
        'nip': {
            "mask": "999-999-99-99",
            showMaskOnHover: false
        },
    });

    this.init = function(obj){
        obj.find('[data-plugin-input-mask]').each(function(){
            let plugin = $(this);
            let config = App.getPluginConfig(plugin, 'plugin-input-mask', {
                showMaskOnHover: false
            });

            Inputmask(config.plugin).mask(plugin[0]);
        });
    };
};

export default PluginInputMask;
